import { normalizeCustomTrackDefinition, type CustomTrackDefinition } from "../game/simulation/customTrackSchema";

/** Bounded, detached snapshots. Failed edits never destroy undo/redo history. */
export class DraftHistory {
  private snapshots: CustomTrackDefinition[];
  private cursor = 0;
  private sequence = 1;
  constructor(input: unknown, private readonly limit = 64) {
    if (!Number.isSafeInteger(limit) || limit < 2 || limit > 256) throw new Error("Invalid history limit");
    this.snapshots = [normalizeCustomTrackDefinition(input)];
  }
  get revision(): number { return this.sequence; }
  get canUndo(): boolean { return this.cursor > 0; }
  get canRedo(): boolean { return this.cursor + 1 < this.snapshots.length; }
  get document(): CustomTrackDefinition { return normalizeCustomTrackDefinition(this.snapshots[this.cursor]); }
  commit(input: unknown): boolean {
    const next = normalizeCustomTrackDefinition(input);
    if (JSON.stringify(next) === JSON.stringify(this.snapshots[this.cursor])) return false;
    this.advanceRevision();
    this.snapshots = this.snapshots.slice(0, this.cursor + 1);
    this.snapshots.push(next);
    if (this.snapshots.length > this.limit) this.snapshots.shift();
    this.cursor = this.snapshots.length - 1;
    return true;
  }
  undo(): boolean {
    if (!this.canUndo) return false;
    this.advanceRevision(); this.cursor--; return true;
  }
  redo(): boolean {
    if (!this.canRedo) return false;
    this.advanceRevision(); this.cursor++; return true;
  }
  private advanceRevision(): void {
    if (this.sequence === Number.MAX_SAFE_INTEGER) throw new Error("Draft revision exhausted");
    this.sequence++;
  }
}
